/**
 * The "this leaves the cabinet" mark.
 *
 * Every guide on this page is rendered by moonx.app and not by us — erratum G28: "the public
 * program / FAQ / terms pages … are rendered by moonx.app, the website; the AUTHORS app hosts only
 * the authenticated surfaces" (`docs/design/00-scope-v1.md`). A reader is entitled to know that
 * before clicking, and the mark is how a link says it without a sentence.
 *
 * IT WAS DRAWN HERE BY HAND, AND IS NOW LUCIDE'S `ExternalLink` (design 15, the owner's live look
 * at real cabinets, 2026-10-01). It used to be four line segments of our own, because `lucide-react`
 * was a dependency of `web/ui` and not of `web/authors`. web/ui now re-exports the icons both apps
 * draw (web/ui/src/icons.ts) and the cabinet's rule is that every icon comes from there, so this is
 * the same glyph from the one set.
 *
 * `aria-hidden` because the accessible name is carried by the link text plus the visually-hidden
 * "(opens on moonx.app)" beside it. An icon that repeats what the text already says is noise in a
 * screen reader.
 */
import { ExternalLink } from '@moonx/ui';
import classes from '../support.module.css';

export function OffsiteMark() {
  return <ExternalLink className={classes.offsiteMark} aria-hidden="true" focusable="false" />;
}
